export class LiftingTariff {
  min_price: number = 0;
  min_hours: number = 1;
  additional_hour_price: number = 0;
}
